// CouponList.jsx
import React, { useState, useRef, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import eyeIcon from "../../assests/eyeIcon.svg";
import search from "../../assests/search.svg";
import leftArrow from "../../assests/leftArrow.svg";
import filterIcon from "../../assests/filterIcon.svg";
import { Link, useNavigate } from "react-router-dom";
import styles from "./CouponList.module.css";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import emotions7 from "../../assests/emotions7.svg";
import LoadingSpinner from "../Loading/component";

export const CouponListComponent = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const filterRef = useRef(null);
  const navigate = useNavigate();

  const addUser = () => navigate("/home/couponcreate");
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);
  const arrowClick = () => navigate("/");

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowFilterDropdown(false);
      }
    };

    if (showFilterDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilterDropdown]);

  // Close dropdown on ESC key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape" && showFilterDropdown) {
        setShowFilterDropdown(false);
      }
    };

    document.addEventListener("keydown", handleEscKey);
    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [showFilterDropdown]);

  return (
    <div className={styles.couponManagementContainer} onClick={() => setShowFilterDropdown(false)}>
      <Sidebar />
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className={styles.couponManagementContent} onClick={(e) => e.stopPropagation()}>
          {props.error && (
            <div className={styles.couponErrorMessageTop}>
              {props.error}
              <button 
                className={styles.couponErrorCloseBtn}
                onClick={() => props.onDismissError()}
              >
                &times;
              </button>
            </div>
          )}
          
          <div className={styles.couponManagementHeader}>
            <button onClick={arrowClick} className={styles.couponBackButton}>
              <img src={leftArrow} alt="Back" />
            </button>
            <h1 className={styles.couponPageTitle}>Coupons</h1>
          </div>

          <div className={styles.couponManagementControls}>
            <div className={styles.couponSearchContainer}>
              <input
                type="search"
                className={styles.couponSearchInput}
                placeholder="Search by Coupon Code / Coupon Id"
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={e => props?.setQuery(e.target.value)}
                value={props?.query || ''}
              />
              <img
                src={search}
                alt="Search"
                className={`${styles.couponSearchIcon} ${isFocused ? styles.couponSearchIconHidden : ""}`}
              />
            </div>
            
            <Button
              onClick={addUser}
              className={styles.couponCreateButton}
              variant="primary"
            >
              + Create Coupon
            </Button>
          </div>

          <div className={styles.couponTableWrapper} ref={props.tableContainerRef}>
            <Table  className={styles.couponDataTable}>
              <thead>
                <tr className={styles.couponTableHeaderRow}>
                  <th className={styles.couponTableHeader}>Sr. No</th>
                  <th className={styles.couponTableHeader}>Coupon Code</th>
                  <th className={styles.couponTableHeader}>Coupon ID</th>
                  <th className={`${styles.couponTableHeader} ${styles.couponStatusHeader}`}>
                    <div className={styles.couponFilterContainer} ref={filterRef}>
                      <span className={styles.couponFilterLabel}>Status</span>
                      <div className={styles.couponFilterDropdownWrapper}>
                        <button 
                          className={styles.couponFilterTrigger}
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowFilterDropdown(!showFilterDropdown);
                          }}
                        >
                          <img src={filterIcon} alt="Filter" className={styles.couponFilterIcon} />
                        </button>
                        {showFilterDropdown && (
                          <div className={styles.couponFilterDropdownMenu}>
                            <div 
                              className={styles.couponFilterOption}
                              onClick={(e) => {
                                e.stopPropagation();
                                props?.setStatusFilter('Activated');
                                setShowFilterDropdown(false);
                              }}
                            >
                              <span className={`${styles.couponFilterOptionDot} ${styles.activated}`}></span>
                              Activated
                            </div>
                            <div 
                              className={styles.couponFilterOption}
                              onClick={(e) => {
                                e.stopPropagation();
                                props?.setStatusFilter('Deactivated');
                                setShowFilterDropdown(false);
                              }}
                            >
                              <span className={`${styles.couponFilterOptionDot} ${styles.deactivated}`}></span>
                              Deactivated
                            </div>
                            <div 
                              className={styles.couponFilterOption}
                              onClick={(e) => {
                                e.stopPropagation();
                                props?.setStatusFilter('All');
                                setShowFilterDropdown(false);
                              }}
                            >
                              <span className={`${styles.couponFilterOptionDot} ${styles.all}`}></span>
                              All
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </th>
                  <th className={styles.couponTableHeader}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {props.filtered?.length > 0 ? (
                  props.filtered.map((item, index) => (
                    <tr key={item.id || item.couponId || index} className={`${styles.couponTableRow} ${styles.couponHoverRow}`}>
                      <td className={styles.couponTableCell}>{index + 1}</td>
                      <td className={styles.couponTableCell}>{item.couponName || item.name || '-'}</td>
                      <td className={styles.couponTableCell}>{item.couponId || item.id || '-'}</td>
                      <td className={styles.couponTableCell}>
                        <span className={`${styles.couponStatusBadge} ${item.status !== "Activated" ? styles.couponStatusDeactivated : styles.couponStatusActivated}`}>
                          {item.status === "Activated" ? "Activated" : "Deactivated"}
                        </span>
                      </td>
                      <td className={`${styles.couponTableCell} ${styles.couponActionCell}`}>
                        <Link to={`/home/coupon/${item.couponId || item.id}`} className={styles.couponViewLink}>
                          <img src={eyeIcon} alt="View" className={styles.couponViewIcon} />
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className={styles.couponEmptyRow}>
                    <td colSpan="5" className={styles.couponEmptyCell}>
                      <div className={styles.couponNoResults}>
                        <img src={emotions7} alt="No coupons found" className={styles.couponNoResultsIcon} />
                        <p className={styles.couponNoResultsText}>{props.error ? "Error loading coupons" : "No Coupon Found"}</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CouponListComponent;